import { ReactElement } from 'react';

import { Modal, ModalCloseButton, ModalConfirmButton, ModalWidth } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../translations';

import { ConsentsAndAuthorizationsDocumentsActionForm } from './ConsentsAndAuthorizationsDocumentsActionForm';

const t = patientConsentsAndAuthorizationsTranslationKeys.consentsAndAuthorizations.modal;

type ConsentsAndAuthorizationsDocumentsModalProps = {
   readonly onClose: VoidFunction;
   readonly patientId: number;
};

export const ConsentsAndAuthorizationsDocumentsModal = (
   props: ConsentsAndAuthorizationsDocumentsModalProps
): ReactElement => {
   return (
      <Modal title={t.title} width={ModalWidth.NORMAL} testId={'consentsAndAuthorizationsDocuments'}>
         <ConsentsAndAuthorizationsDocumentsActionForm onApproveAndPrint={props.onClose} patientId={props.patientId} />

         <ModalConfirmButton label={t.actions.close} onClick={props.onClose} />
         <ModalCloseButton onClick={props.onClose} />
      </Modal>
   );
};
